// app/theme.ts
import { createTheme, type MantineColorsTuple } from "@mantine/core";

const myColor: MantineColorsTuple = [
  "#ffeee4",
  "#ffdccd",
  "#ffb79b",
  "#ff8f64",
  "#fe6e37",
  "#fe5819",
  "#ff4701",
  "#e43e00",
  "#cb3500",
  "#b22a00",
];
export const theme = createTheme({
  fontFamily: "DM Sans, sans-serif",
  // Uses Mantine's native orange palette
  primaryColor: "orange",

  // // Default color configuration
  // defaultGradient: {
  //   from: 'orange.6',
  //   to: 'orange.8',
  //   deg: 45,
  // },

  // // Global colors
  // other: {
  //   backgroundColor: '#f3f3f3', // Off-white background
  // },
  colors: {
    myColor,
  },

  spacing: {
    xxs: "4px",
    xs: "8px",
    sm: "12px",
    md: "16px",
    lg: "20px",
    xl: "32px",
  },

  components: {
    Title: {
      defaultProps: {
        c: "#3B3B3B",
      },
    },
    Text: {
      defaultProps: {
        c: "#3B3B3B",
      },
    },
  },
});
